import { TkOrderListing } from '../../OrderTable/types.ts';
import { OrderCardBadge } from '../types.ts';

export const getBadgeFromOrder = (order: TkOrderListing): OrderCardBadge | undefined => {
  if (!order.isCraftsman) {
    return { text: 'Legacy', variant: 'tertiary' };
  }

  if (order.isTraining) {
    return { text: 'Training', variant: 'primary' };
  }

  return undefined;
};
